import type { JSX } from 'react';

import {
  WelcomeAvatarFactory,
  WelcomeBodyFactory,
  WelcomeFactory,
  WelcomeInitialFactory,
  WelcomeNameFactory,
  WelcomeStatusFactory,
} from '@/components/AppLayout/components/WelcomeSection/WelcomeSection.factory';
import { useAuthentication } from '@/hooks/queries/authentication/useAuthentication';

export function WelcomeSection({ className }: { className?: string }): JSX.Element | null {
  const { data: user } = useAuthentication();
  if (!user) return null;

  const initial = user.nome?.charAt(0).toUpperCase() ?? '?';

  return (
    <WelcomeFactory className={className}>
      <WelcomeAvatarFactory>
        <WelcomeInitialFactory>{initial}</WelcomeInitialFactory>
        <WelcomeStatusFactory />
      </WelcomeAvatarFactory>
      <WelcomeBodyFactory>
        <WelcomeNameFactory>Olá, {user.nome}</WelcomeNameFactory>
      </WelcomeBodyFactory>
    </WelcomeFactory>
  );
}
